export default __webpack_public_path__ + "static/media/roll.48ad9220.png";